module.exports = __webpack_public_path__ + "img/bater-papo.d56d4e59.png";